import type { Input as ButtonInput } from "../evo-button/index.marko";
import type {
    BackgroundColor,
    PaddingSize,
} from "../content-section/index.marko";
import type { AttrClass } from "node_modules/marko/tags-html";
import s from "./style.module.css";
export interface Input {
    headline: Marko.AttrTag<Marko.HTML.H2>;
    body?: Marko.AttrTag<Marko.HTML.P>;
    cta?: Marko.AttrTag<ButtonInput>;
    align?: "center" | "left";
    paddingBlock?: (PaddingSize | null)[];
    background?: BackgroundColor[];
    class?: AttrClass;
}

<const/{
    headline,
    body,
    paddingBlock,
    cta,
    align = "center",
    background,
    class: className,
}=input>

<content-section
    class=[s.section, className]
    data-align=align
    paddingBlock=paddingBlock
    background=background>
    <text-stack align=align>
        <@headline>
            <${headline.content}/>
        </@headline>
        <if=body>
            <@body>
                <${body.content}/>
            </@body>
        </if>
        <if=cta>
            <@cta ...cta/>
        </if>
    </text-stack>
</content-section>
